/* eslint-disable consistent-return */
import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withContent from '../../../containers/withContent';
import pageContent from '../../../payees/components/AddNewPayeeLandingPage/index.content';
import AddPayeeForm from '../../../payees/components/AddPayeeForm';
import AddInternationalPayeeForm from '../../../payees/components/AddInternationalPayeeForm';
import { withScrollTop } from '../../../containers/withScrollTop';
import {
	getEditPayeeDetails,
	getLinkAccountDetails,
	getAddPayeeFormDetails,
	getIsPayeeDeleted,
	isValidChapsCharsFormat,
} from '../../../payees/states/addPayee/selectors';
import { getSelectedPaymentId } from '../../../states/payeeSelector/selectors';
import { setSelectedPayee } from '../../../managePayee/states/action';
import { addPayeeFormPropTypes, linkAccountDetailsPropTypes } from '../../../payees/states/addPayee/propTypes';
import {
	setAddPayeeForm,
	submitAddPayeeRequest,
	updateBeneficiaryEvent,
	beneficiaryEventsFailure,
	submitInternationalAddPayeeRequest,
	setGenericError,
	resetAddPayeeForm,
} from '../../../payees/states/addPayee/actions';
import {
	showAllErrors,
	initValidationForEditPayee,
	deleteValidationField,
	removeKey,
} from '../../../states/validation/actions';
import { handleRemovePayment } from '../../../states/payments/actions';
import {
	getLastPayment,
	getPaymentsFromPreviousPage,
	getSinglePaymentIdByToAccountFromPaymentType,
} from '../../../states/payments/selectors';
import { isSpecificFormValid } from '../../../states/validation/selectors';
import { getBankId, getClientContext, getToken } from '../../../states/session/selectors';
import {
	getSourceAccountId,
	isInternationalPayee,
	getScheduledPaymentsModalContentKey,
	getAccountNameServicesError,
	getIsCOPEdit,
} from '../../states/selectors';
import { setEditPayeeFlag, submitDeletePayeeRequest, SUBMIT_DELETE_PAYEE_SUCCESS } from '../../states/action';
import { getApiBaseUrlPaas } from '../../../states/envConfig/selectors';
import COP from '../../../cop/components/App/App';
import { goBackPage, pages } from '../../../states/page/actions';
import ScheduledPaymentsModal from '../../components/ScheduledPaymentsModal';
import { copCustomerType } from '../../../config/';
import { isCopCheckRequired, formatCOPDetails } from '../../../helpers/fieldHelpers';
import { getUserId } from '../../../states/user/selectors';
import { getSelectedPayeeDetails } from '../../states/selectors';
import { getCopResult } from '../../../cop/states/selectors';
import { getConfirmationOfPayeeCopCheckError, getConfirmationOfPayeeCopCheckSuccess } from '../../../utils/payeeUtils';
import { setSelectedPaymentId } from '../../../states/payeeSelector/actions';
import { removePayee } from '../../../states/payees/actions';
import { isPaymentInEditMode } from '../../../states/modes/selectors';

const mapState = (state, props) => ({
	payeeDetails: getEditPayeeDetails(state),
	formValid: isSpecificFormValid(state, props.id),
	sourceAccountId: getSourceAccountId(state),
	addPayeeForm: getAddPayeeFormDetails(state),
	linkAccountDetails: getLinkAccountDetails(state, props.accountsForAddPayee),
	bankId: getBankId(state),
	apiBaseUrlPaas: getApiBaseUrlPaas(state),
	clientContext: getClientContext(state),
	isInternationalPayee: isInternationalPayee(state),
	token: getToken(state),
	isPayeeDeleted: getIsPayeeDeleted(state),
	scheduledPaymentsModalContentKey: getScheduledPaymentsModalContentKey(state),
	isValidChapsCharsFormat: isValidChapsCharsFormat(state),
	customerId: getUserId(state),
	selectedPayee: getSelectedPayeeDetails(state),
	getCopResult: getCopResult(state),
	lastPayment: getLastPayment(state),
	hasAccountNameServicesError: getAccountNameServicesError(state),
	selectedPaymentId: getSelectedPaymentId(state),
	payments: getPaymentsFromPreviousPage(state),
	isCOPEdit: getIsCOPEdit(state),
	getPaymentId: (toAccount) => getSinglePaymentIdByToAccountFromPaymentType(state, toAccount),
	paymentInEditMode: isPaymentInEditMode(state),
});

const mapDispatch = (dispatch, props) => ({
	setAddPayeeForm: (payeeDetails) => dispatch(setAddPayeeForm(payeeDetails)),
	showAllErrors: () => dispatch(showAllErrors(props.id)),
	submitDeletePayeeRequest: (sourceAccountId) => dispatch(submitDeletePayeeRequest(sourceAccountId)),
	deleteValidationField: (id, fieldId) => dispatch(deleteValidationField(id, fieldId)),
	initValidationForEditPayee: (payeeDetails) => dispatch(initValidationForEditPayee(props.id, payeeDetails)),
	submitAddPayeeRequest: ({ payeeDetails, account, copDetails, isEdit }) =>
		dispatch(submitAddPayeeRequest({ id: props.id, payeeDetails, account, copDetails, isEdit })),
	setEditPayeeFlag: () => dispatch(setEditPayeeFlag()),
	beneficiaryEventsFailure: () => dispatch(beneficiaryEventsFailure()),
	submitInternationalAddPayeeRequest: (addPayeeForm, linkAccountDetails, isEdit) =>
		dispatch(submitInternationalAddPayeeRequest(props.id, addPayeeForm, linkAccountDetails, isEdit)),
	removeKey: (idObj) => dispatch(removeKey(idObj)),
	setGenericError: (errorCode) => dispatch(setGenericError(errorCode)),
	resetAddPayeeForm: () => dispatch(resetAddPayeeForm(props.id)),
	goBackPage: () => dispatch(goBackPage()),
	handleRemovePayment: (id) => dispatch(handleRemovePayment(id)),
	setSelectedPayee: (payee) => dispatch(setSelectedPayee(payee)),
	selectPayment: (paymentId) => dispatch(setSelectedPaymentId(paymentId)),
	removePayee: (payeeId) => dispatch(removePayee(payeeId)),
});

export class EditPayee extends Component {
	constructor(props) {
		super(props);
		this.state = { showScheduledPaymentsModal: false, showCopCheck: false };
		this.handleAddPayeeSubmit = this.handleAddPayeeSubmit.bind(this);
		this.handleSubmission = this.handleSubmission.bind(this);
		this.handleAddInternationalPayeeSubmit = this.handleAddInternationalPayeeSubmit.bind(this);
		this.handleScheduledPaymentsModalConfirmClick = this.handleScheduledPaymentsModalConfirmClick.bind(this);
		this.renderPayeeForm = this.renderPayeeForm.bind(this);
		this.handleCOPSuccess = this.handleCOPSuccess.bind(this);
		this.handleCOPCancel = this.handleCOPCancel.bind(this);
		this.handleCOPEdit = this.handleCOPEdit.bind(this);
	}

	componentWillMount() {
		const { setAddPayeeForm, payeeDetails, initValidationForEditPayee } = this.props;
		initValidationForEditPayee(payeeDetails);
		setAddPayeeForm(payeeDetails);
	}

	componentWillUnmount() {
		const { removeKey, id } = this.props;
		removeKey({ id });
	}

	handleEditGoBack = () => {
		const { isCOPEdit, goBackPage, getPaymentId, handleRemovePayment, selectedPayee } = this.props;

		if (isCOPEdit) {
			this.handleCOPCancel();
		} else {
			handleRemovePayment(getPaymentId(get(selectedPayee, 'id')));
			goBackPage();
		}
	};

	handleScheduledPaymentsModalConfirmClick() {
		const { isInternationalPayee, addPayeeForm, payeeDetails } = this.props;

		this.isScheduledPaymentsWarningShown = true;
		this.setState({ showScheduledPaymentsModal: false });
		if (isInternationalPayee) {
			return this.handleAddInternationalPayeeSubmit();
		}
		if (isCopCheckRequired(addPayeeForm, payeeDetails)) {
			return this.setState({ showCopCheck: true });
		}
		this.handleSubmission(formatCOPDetails(payeeDetails.payeeCopDetails));
	}

	handleAddPayeeSubmit() {
		const {
			showAllErrors,
			formValid,
			addPayeeForm,
			setEditPayeeFlag,
			isValidChapsCharsFormat,
			setGenericError,
			payeeDetails,
		} = this.props;

		setEditPayeeFlag();
		if (!formValid) return showAllErrors();
		if (!isValidChapsCharsFormat) {
			window.scrollTo(0, 0);
			return setGenericError('incorrectDetailsForChaps');
		}
		if (!this.isScheduledPaymentsWarningShown) {
			return this.setState({ showScheduledPaymentsModal: true });
		}
		if (isCopCheckRequired(addPayeeForm, payeeDetails)) {
			return this.setState({ showCopCheck: true });
		}
		this.handleSubmission(formatCOPDetails(payeeDetails.payeeCopDetails));
	}

	handleSubmission() {
		const {
			submitDeletePayeeRequest,
			sourceAccountId,
			bankId,
			submitAddPayeeRequest,
			addPayeeForm,
			linkAccountDetails,
			apiBaseUrlPaas,
			clientContext,
			beneficiaryEventsFailure,
			token,
			isPayeeDeleted,
			payeeDetails,
			getCopResult = {},
			hasAccountNameServicesError,
			removePayee,
			selectedPayee,
		} = this.props;

		const { result } = getCopResult;
		const copResult = hasAccountNameServicesError
			? getConfirmationOfPayeeCopCheckError()
			: getConfirmationOfPayeeCopCheckSuccess(result);
		const payeeCopDetails = this.state.showCopCheck ? copResult : payeeDetails.payeeCopDetails;

		const copDetails = {
			payeeName: getCopResult.payeeName || get(addPayeeForm, 'name', ''),
			payeeType: getCopResult.payeeType || get(addPayeeForm, 'copType'),
			result: {
				...payeeCopDetails,
			},
		};
		if (!isPayeeDeleted) {
			submitDeletePayeeRequest(sourceAccountId).then((response) => {
				if (response.type === SUBMIT_DELETE_PAYEE_SUCCESS) {
					removePayee(selectedPayee.id);
					submitAddPayeeRequest({
						payeeDetails: addPayeeForm,
						account: linkAccountDetails,
						copDetails,
						isEdit: true,
					});
				}
			});
		} else {
			submitAddPayeeRequest({ payeeDetails: addPayeeForm, account: linkAccountDetails, copDetails, isEdit: true });
		}

		updateBeneficiaryEvent({
			bankId,
			apiBaseUrlPaas,
			addPayeeForm,
			clientContext,
			beneficiaryEventsFailure,
			token,
		});
	}

	handleAddInternationalPayeeSubmit() {
		const {
			showAllErrors,
			formValid,
			submitDeletePayeeRequest,
			sourceAccountId,
			submitInternationalAddPayeeRequest,
			addPayeeForm,
			linkAccountDetails,
			setEditPayeeFlag,
			isPayeeDeleted,
		} = this.props;

		setEditPayeeFlag();

		if (!formValid) return showAllErrors();
		if (!this.isScheduledPaymentsWarningShown) {
			return this.setState({ showScheduledPaymentsModal: true });
		}
		if (!isPayeeDeleted) {
			submitDeletePayeeRequest(sourceAccountId).then((response) => {
				if (response.type === SUBMIT_DELETE_PAYEE_SUCCESS) {
					submitInternationalAddPayeeRequest(addPayeeForm, linkAccountDetails, true);
				}
			});
		} else {
			submitInternationalAddPayeeRequest(addPayeeForm, linkAccountDetails, true);
		}
	}
	renderPayeeForm() {
		const { id, isInternationalPayee } = this.props;
		if (isInternationalPayee) {
			return (
				<AddInternationalPayeeForm
					id={id}
					handleAddInternationalPayeeSubmit={this.handleAddInternationalPayeeSubmit}
					isEditPayee
				/>
			);
		}
		return (
			<AddPayeeForm
				id={id}
				handleAddPayeeSubmit={this.handleAddPayeeSubmit}
				handleGoBack={this.handleEditGoBack}
				isEditPayee
			/>
		);
	}

	handleCOPCancel() {
		const {
			lastPayment: { id: paymentId },
			handleRemovePayment,
			selectedPaymentId: isPaymentBeingEdited,
			setSelectedPayee,
			paymentInEditMode,
		} = this.props;

		if (paymentInEditMode || isPaymentBeingEdited) {
			setSelectedPayee(null);
		} else if (paymentId) {
			handleRemovePayment(paymentId);
		}
		this.props.goBackPage();
	}

	handleCOPEdit() {
		this.setState({ showCopCheck: false });
	}

	handleCOPSuccess(copDetails) {
		const {
			lastPayment: { id: lastPaymentId },
			selectedPaymentId: isPaymentCurrentlySelected,
			selectPayment,
			payments,
		} = this.props;

		/**
		 * @todo Needed to add a fallback here as payments was empty because the logic doesn't suit every previous page possibility
		 * lastPayment was pointing at the payment, and payments was empty.
		 *
		 * @note DP
		 * Included simple fallback, but leaving the note
		 * in case we need to extend/correct it in the future.
		 */
		const fallbackPaymentId = payments?.[0]?.id ?? lastPaymentId;
		if (!isPaymentCurrentlySelected && fallbackPaymentId) {
			selectPayment(fallbackPaymentId);
		}

		this.handleSubmission(copDetails);
	}

	render() {
		const { copCheckTriggered, scheduledPaymentsModalContentKey, customerId, addPayeeForm, sessionCOPChecks } =
			this.props;

		const { showScheduledPaymentsModal, showCopCheck } = this.state;

		if (showCopCheck) {
			const copDetails = {
				accountName: addPayeeForm.name,
				accountNumber: addPayeeForm.accountNumber,
				sortCode: addPayeeForm.sortCode,
				accountType: addPayeeForm.copType,
				reference: addPayeeForm.reference,
				customerId: customerId,
				customerType: copCustomerType.Business,
				page: pages.COP.MakeMatch,
			};
			return (
				<COP
					copCheckTriggered={copCheckTriggered}
					cop={copDetails}
					handleComplete={this.handleCOPSuccess}
					handleCancel={this.handleCOPCancel}
					handleEdit={this.handleCOPEdit}
					initStore={false}
					sessionCOPChecks={sessionCOPChecks}
				/>
			);
		}
		return (
			<span>
				{showScheduledPaymentsModal && (
					<ScheduledPaymentsModal
						isModalOpen={showScheduledPaymentsModal}
						handleClose={() => this.setState({ showScheduledPaymentsModal: false })}
						handleConfirmClick={this.handleScheduledPaymentsModalConfirmClick}
						contentKey={scheduledPaymentsModalContentKey}
					/>
				)}
				{this.renderPayeeForm()}
			</span>
		);
	}
}

EditPayee.propTypes = {
	payeeDetails: PropTypes.shape(addPayeeFormPropTypes).isRequired,
	setAddPayeeForm: PropTypes.func.isRequired,
	showAllErrors: PropTypes.func.isRequired,
	initValidationForEditPayee: PropTypes.func.isRequired,
	formValid: PropTypes.bool.isRequired,
	bankId: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	sourceAccountId: PropTypes.string.isRequired,
	submitDeletePayeeRequest: PropTypes.func.isRequired,
	submitAddPayeeRequest: PropTypes.func.isRequired,
	addPayeeForm: PropTypes.shape(addPayeeFormPropTypes).isRequired,
	linkAccountDetails: PropTypes.shape(linkAccountDetailsPropTypes).isRequired,
	setEditPayeeFlag: PropTypes.func.isRequired,
	beneficiaryEventsFailure: PropTypes.func.isRequired,
	submitInternationalAddPayeeRequest: PropTypes.func.isRequired,
	apiBaseUrlPaas: PropTypes.string.isRequired,
	clientContext: PropTypes.string.isRequired,
	isInternationalPayee: PropTypes.bool.isRequired,
	token: PropTypes.string.isRequired,
	isPayeeDeleted: PropTypes.bool.isRequired,
	removeKey: PropTypes.func.isRequired,
	scheduledPaymentsModalContentKey: PropTypes.string.isRequired,
	isValidChapsCharsFormat: PropTypes.bool.isRequired,
	setGenericError: PropTypes.func.isRequired,
	isCOPEdit: PropTypes.bool.isRequired,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
	getPaymentId: PropTypes.func,
	paymentInEditMode: PropTypes.bool,
};

export default compose(connect(mapState, mapDispatch), withScrollTop, withContent({ content: pageContent }))(EditPayee);
